import React from 'react';

import { Portal } from '@headlessui/react';

import { Button } from '../../Clickables/Buttons/Button';
import { SearchIcon } from '../../Icons/SearchIcon';

interface IProps {
  setIsActive: (isActive: boolean) => void;
  isActive: boolean;
  children: React.ReactElement;
}

export const MobileSearch = ({ setIsActive, isActive, children }: IProps) => {
  if (isActive) {
    return (
      <Portal>
        <div className="z-modal bg-sea-foam absolute top-0 h-full md:min-h-[80px]">{children}</div>
      </Portal>
    );
  }
  return (
    <Button
      className="bg-sea-foam text-midnight relative mt-4 ml-4 flex size-9 items-center justify-center rounded-full"
      onClick={() => {
        setIsActive(true);
      }}
      variant="buttonNone"
      data-testid="map-mobile-search-icon"
    >
      <SearchIcon />
    </Button>
  );
};
